import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';
import { ReviewIO as ReviewIOComponent } from 'ggApp/shared/components/ReviewIO';

import LogoSvg from './images/logo.svg';
import CloseIcon from './images/close.svg';


export const Navigation = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.secondary};
    width: 300px;
    margin-left: 30px;

    @media (${screens.desktop}) and (${screens.largeDesktopMax}) {
        width: 240px;
    }

    @media (${screens.phone}) and (${screens.desktopMax}) {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        margin: 0;
        min-height: 0;
        height: 100%;

        transition: all 0.4s ease;
        transform: translateX(0%);

        overflow: scroll;
        -webkit-overflow-scrolling: touch;

        ${({ hide }) => hide && css`
            transform: translateX(100%);
        `}
    }
`;

export const Wrap = styled.div`
    position: relative;
    flex: 1;
    padding-top: 100px;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
`;

export const Logo = styled.div`
    width: 100%;
    height: 175px;
    background-image: url(${LogoSvg});
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: auto 55px;
`;

export const Close = styled.div`
    @media (${screens.phone}) and (${screens.desktopMax}) {
        width: 55px;
        height: 55px;
        top: 0;
        background-image: url(${CloseIcon});
        background-repeat: no-repeat;
        background-size: auto;
        background-position: 50% 50%;
        cursor: pointer;
        position: absolute;
        right: 0;
        z-index: 1;
    }
`;

export const Footer = styled.div`
    @media (${screens.phone}) and (${screens.desktopMax}) {
        text-align: center;
        color: #fff;
        font-size: 12px;
        line-height: 1.35;
        letter-spacing: 0.3px;
        padding: 0 30px 30px;
    }
`;

export const ReviewIO = styled(ReviewIOComponent)`
    @media (${screens.phone}) and (${screens.desktopMax}) {
        justify-content: center;
        margin-bottom: 10px;

        & > * {
            color: #fff !important;
        }

        & > a > svg > path {
            fill: #fff;
        }
    }
`;
